<script>
const counter = [
    {
        key: 'counter',
        title: 'No',
        align: 'center',
        scopedSlots: {customRender: 'counter'},
    },
]

const columnsCoaching = [

    {
        key: 'coach_goal',
        title: 'Tujuan(Goal)',
        align: 'center',
        scopedSlots: {customRender: 'coach_goal'},
    },
    {
        key: 'coach_reality',
        title: 'Kebutuhan Yang Terungkap (Reality)',
        align: 'center',
        scopedSlots: {customRender: 'coach_reality'},
    },
    {
        key: 'coach_option',
        title: 'Pilihan-pilihan (Option)',
        align: 'center',
        scopedSlots: {customRender: 'coach_option'},
    },
    {
        key: 'coach_will',
        title: 'Tindakan/Komitmen Yang Diambil (Will)',
        align: 'center',
        scopedSlots: {customRender: 'coach_will'},
    },
    {
        key: 'control',
        title: 'Action',
        align: 'center',
        scopedSlots: {customRender: 'control'},
    }
]

const columnsMentor = [
    {
        key: 'date',
        title: 'Tanggal',
        align: 'center',
        scopedSlots: {customRender: 'date'},
    },
    {
        key: 'time_start',
        title: 'Waktu Mulai',
        align: 'center',
        scopedSlots: {customRender: 'time_start'},
    },
    {
        key: 'time_end',
        title: 'Waktu Selesai',
        align: 'center',
        scopedSlots: {customRender: 'time_end'},
    },
    {
        key: 'name',
        title: 'Pegawai',
        align: 'center',
        scopedSlots: {customRender: 'name'},
    },
    {
        key: 'category',
        title: 'Kategori',
        align: 'center',
        scopedSlots: {customRender: 'category'},
    },
]

const columnsMentoring = [
    {
        key: 'mentoring_competency',
        title: 'Kompetensi Yang Dikembangkan',
        align: 'center',
        scopedSlots: {customRender: 'mentoring_competency'},
    },
    {
        key: 'mentoring_aspect',
        title: 'Objek/Aspek Kompetensi',
        align: 'center',
        scopedSlots: {customRender: 'mentoring_aspect'},
    },
    {
        key: 'mentoring_steps',
        title: 'Tahapan Mentoring',
        align: 'center',
        scopedSlots: {customRender: 'mentoring_steps'},
    },
    {
        key: 'mentoring_method',
        title: 'Metode Mentoring',
        align: 'center',
        scopedSlots: {customRender: 'mentoring_method'},
    },
    {
        key: 'target_time',
        title: 'Target Waktu',
        align: 'center',
        scopedSlots: {customRender: 'target_time'},
    },
    {
        key: 'mentoring_way',
        title: 'Cara Monitoring',
        align: 'center',
        scopedSlots: {customRender: 'mentoring_way'},
    },
    {
        key: 'kpi',
        title: 'KPI',
        align: 'center',
        scopedSlots: {customRender: 'kpi'},
    },
    {
        key: 'control',
        title: 'Action',
        align: 'center',
        scopedSlots: {customRender: 'control'},
    }
]

const columnsCounseling = [
    {
        key: 'counseling_object',
        title: 'Objek/Aspek Counseling',
        align: 'center',
        scopedSlots: {customRender: 'counseling_object'},
    },{
        key: 'counseling_date',
        title: 'Tanggal Counseling',
        align: 'center',
        scopedSlots: {customRender: 'counseling_date'},
    },
    {
        key: 'counseling_progress',
        title: 'Progress',
        align: 'center',
        scopedSlots: {customRender: 'counseling_progress'},
    },
    {
        key: 'control',
        title: 'Action',
        align: 'center',
        scopedSlots: {customRender: 'control'},
    }
]

export default {
    props: {
        type: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            columnsCoaching,
            columnsMentoring,
            columnsCounseling,
            counter,
            columnsMentor,
            loading: false,
            items: {
                cmcs: []
            },
            coach_id: '',
            visible: false,
            filters: {
                q: null,
                membership: 'mentor'
            },
            cmc: null,
            document: null
        };
    },
    created() {
        this.getItems()
    },
    computed: {
        columns() {
            switch(this.type){
                case 'coaching':
                    return !this.isAttendant ? [...this.counter, ...this.columnsMentor, ...this.columnsCoaching] : [...this.counter, ...this.columnsCoaching]
                case 'mentoring':
                    return !this.isAttendant ? [...this.counter, ...this.columnsMentor, ...this.columnsMentoring] : [...this.counter, ...this.columnsMentoring]
                case 'counceling':
                    return !this.isAttendant ? [...this.counter, ...this.columnsMentor, ...this.columnsCounseling] : [...this.counter, ...this.columnsCounseling]
            }
        },
        isAttendant() {
            return this.$laravel.membership.is_attendant
        }
    },
    methods: {
        getItems() {
            this.loading = true;

            if(this.isAttendant)
                this.filters.membership = 'member'

            this.$http
                .get(this.routeUri("api.cmc", { type: this.type}), {
                    params: this.filters
                })
                .then(response => this.items = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        addForm(){
            let params = {
                type: this.type,
                title: this.title
            }
            window.location.href = this.routeUri("admin.performance.cmc.form") + '?' + this.$qs.stringify(params)
        },
        detail(id){
            let params = {
                type: this.type,
                title: this.title,
                edit: 1,
                cmc: id
            }

            window.location.href = this.routeUri('admin.performance.cmc.form.edit') + '?' + this.$qs.stringify(params)
        },
        onChange(date, dateString) {
            this.filters.month = dateString
            this.getItems()
        },
        showImage(id){
            this.visible = true
            this.document = 'image'
            this.cmc = id
        },
        showVideo(id){
            this.visible = true
            this.document = 'video'
            this.cmc = id
        },
        showFile(id){
            this.visible = true
            this.document = 'file'
            this.cmc = id
        },
        handleClose() {
            this.visible = false;
        },
    },
}
</script>

<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="title">
            <br>
            <common-training-header />
        </a-page-header>

        <div class="text-right" style="margin-bottom: 24px">
            <a-space>
                <a-month-picker placeholder="Pilih bulan" @change="onChange" /> <a-button type="primary" icon="plus" @click="addForm('')" v-if="!isAttendant">Tambah </a-button>
            </a-space>
        </div>

        <a-card type="inner" size="small">
            <a-skeleton :loading="loading" active>
                <a-table class="pcp-table" :columns="columns" :dataSource="items.cmcs" rowKey="id" :pagination="false" bordered>

                    <div slot="counter" slot-scope="text, record, index">
                        <strong>{{ index+1 }}</strong>
                    </div>

                    <div slot="date" slot-scope="text, record, index">
                        {{ record.cmc_date }}
                    </div>

                    <div slot="time_start" slot-scope="text, record, index">
                        {{ record.time_start }}
                    </div>

                    <div slot="time_end" slot-scope="text, record, index">
                        {{ record.time_end }}
                    </div>

                    <div slot="name" slot-scope="record" style="text-align: left">
                        <li v-for="item in record.attendants">
                            <a-icon type="user" /> {{ item.user.name }}
                        </li>
                    </div>

                    <div slot="category" slot-scope="text, record, index">
                        {{ record.category }}
                    </div>

                    <div slot="bahasan" slot-scope="record" style="text-align: left">
                        {{ record.topic }}
                    </div>

                    <div slot="mentor" slot-scope="record" style="text-align: left">
                        {{ record.cmc_mentor }}
                    </div>

                    <div slot="konselor" slot-scope="record" style="text-align: left">
                        {{ record.cmc_mentor }}
                    </div>

                    <div slot="coach_will" slot-scope="record" style="text-align: left">
                        {{ record.coach_will }}
                    </div>

                    <div slot="coach_goal" slot-scope="record" style="text-align: left">
                        {{ record.coach_goal }}
                    </div>

                    <div slot="coach_reality" slot-scope="record" style="text-align: left">
                        {{ record.coach_reality }}
                    </div>

                    <div slot="coach_option" slot-scope="record" style="text-align: left">
                        {{ record.coach_option }}
                    </div>

                    <div slot="coach_will" slot-scope="record" style="text-align: left">
                        {{ record.coach_will }}
                    </div>


                    <div slot="mentoring_competency" slot-scope="record" style="text-align: left">
                        {{ record.mentoring_competency }}
                    </div>

                    <div slot="mentoring_aspect" slot-scope="record" style="text-align: left">
                        {{ record.mentoring_aspect }}
                    </div>

                    <div slot="mentoring_steps" slot-scope="record" style="text-align: left">
                        {{ record.mentoring_steps }}
                    </div>

                    <div slot="mentoring_way" slot-scope="record" style="text-align: left">
                        {{ record.mentoring_way }}
                    </div>

                    <div slot="mentoring_method" slot-scope="record" style="text-align: left">
                        {{ record.mentoring_method }}
                    </div>

                    <div slot="target_time" slot-scope="record" style="text-align: left">
                        {{ record.cmc_time_target }}
                    </div>

                    <div slot="mentoring_way" slot-scope="record" style="text-align: left">
                        {{ record.mentoring_way }}
                    </div>

                    <div slot="kpi" slot-scope="record" style="text-align: left">
                        {{ record.mentoring_kpi }}
                    </div>


                    <div slot="counseling_object" slot-scope="record" style="text-align: left">
                        {{ record.counseling_object }}
                    </div>

                    <div slot="counseling_progress" slot-scope="record" style="text-align: left">
                        {{ record.counseling_progress }}
                    </div>

                    <div slot="counseling_date" slot-scope="record" style="text-align: left">
                        {{ record.cmc_date }}
                    </div>

                    <div slot="control" slot-scope="record">
                        <a-space>
                            <a-tooltip title="Image">
                                <a-button
                                    style="margin-left: 4px;"
                                    size="small"
                                    icon="file-image"
                                    @click="showImage(record.id)"
                                />
                            </a-tooltip>
                            <a-tooltip title="File">
                                <a-button
                                    style="margin-left: 4px;"
                                    size="small"
                                    icon="file"
                                    @click="showFile(record.id)"
                                />
                            </a-tooltip>
                            <a-tooltip title="Video">
                                <a-button
                                    style="margin-left: 4px;"
                                    size="small"
                                    icon="video-camera"
                                    @click="showVideo(record.id)"
                                />
                            </a-tooltip>
                            <a-tooltip title="Edit" v-if="!isAttendant">
                                <a-button
                                    style="margin-left: 4px;"
                                    size="small"
                                    type="primary"
                                    icon="edit"
                                    @click="detail(record.id)"
                                />
                            </a-tooltip>
                        </a-space>
                    </div>
                </a-table>
            </a-skeleton>

        </a-card>

        <a-modal
            :visible="visible"
            :destroyOnClose="true"
            :footer="null"
            :closable="false"
        >
            <a-card type="inner" size="small" :title="document === 'image' ? 'Dokumentas: Foto' : (document === 'video' ? 'Dokumentasi: Video' : 'Dokumentasi: File')">
                <documentation :type="type" :cmc="cmc" :document="document" />
                <a-row type="flex" justify="center" align="top" style="margin-top: 12px">
                    <a-col>
                        <a-button
                            @click="handleClose"
                        >Tutup</a-button>
                    </a-col>
                </a-row>
            </a-card>
        </a-modal>
    </div>
</template>
